export default {
      id: "zoom_minus-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#zoom_minus",
      toString: function () {
        return this.url;
      }
    }